module.exports = __webpack_public_path__ + "static/media/javier.5a9f8300.jpg";